import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BoschUiHeaderRowDefDirective } from '../directives/bosch-ui-header-row-def.directive';
import { BoschUiTableService } from '../bosch-ui-table.service';

@Component({
  selector: 'bosch-ui-table-header-row',
  templateUrl: './bosch-ui-table-header-row.component.html',
  styleUrls: ['./bosch-ui-table-header-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BoschUiTableHeaderRowComponent<DataType> {
  public readonly tableService = inject(BoschUiTableService<DataType>);
  private readonly boschUiRowDefDirective = inject(BoschUiHeaderRowDefDirective<DataType>, { host: true });

  public rowDisplayColumns = this.boschUiRowDefDirective.headerRowDisplayColumns;
}
